export const makeElement = (name) => document.createElementNS('http://www.w3.org/2000/svg', name);

export default makeElement;